import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DefaultEndUserRequest, EndUser } from '../models/generated/ziroModels';
import { Observable } from 'rxjs';

@Injectable()
export class DefaultEndUserResource {
  private http = inject(HttpClient);

  post(request: DefaultEndUserRequest): Observable<EndUser> {
    return this.http.post<EndUser>('/services/cisco/defaults/end-user', {
      ...request,
    });
  }
}
